import React, { PureComponent } from "react";
import { CHECKBOX_CHECKED, CHECKBOX_INDETERMINATE } from "Config";
import styles from "./Item.local.scss";

class CheckBox extends PureComponent {
  render() {
    const { state } = this.props;
    return (
      <div className={styles.checkbox}>
        <label
          onClick={event => {
            event.stopPropagation();
          }}
        >
          <input
            type="checkbox"
            onChange={this.props.handleSelectCheckbox}
            checked={state === CHECKBOX_CHECKED}
          />
          {state === CHECKBOX_INDETERMINATE ? <div /> : <span />}
        </label>
      </div>
    );
  }
}

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/OrganizationList/CheckBox.js